<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="12">
            <a-form-item label="用户账号">
              <!--<a-input placeholder="请输入用户账号查询" v-model="queryParam.username"></a-input>-->
              <j-input placeholder="输入用户账号模糊查询" v-model="queryParam.username"></j-input>
            </a-form-item>
          </a-col>



      <a-col :md="6" :sm="8">
            <a-form-item label="工号">
              <!--<a-input placeholder="请输入工号查询" v-model="queryParam.username"></a-input>-->
              <j-input placeholder="输入工号模糊查询" v-model="queryParam.workNo"></j-input>
            </a-form-item>
          </a-col>


          <a-col :md="6" :sm="8">
              <a-form-item label="用户姓名">
                <j-input placeholder="请输入用户姓名" v-model="queryParam.realname"></j-input>
              </a-form-item>
            </a-col>


          <a-col :md="6" :sm="8">
            <a-form-item label="性别">
              <a-select v-model="queryParam.sex" placeholder="请选择性别">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="1">男</a-select-option>
                <a-select-option value="2">女</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="10" :lg="11" :md="12" :sm="24" v-if="application.applicationType === 'platform'">
            <a-form-item :label="language['application']">
              <a-select v-model="queryParam.selectedApplicationId" allowClear  :placeholder="language['common.pleaseChoose']+language['application']" style="width: 35%;padding-right: 10px">
                <a-select-option v-for="(item,index) in applicationOptions" :key="index" :value="item.id" allowClear>
                  {{ item.applicationName }}
                </a-select-option>
              </a-select>
              <a-radio-group v-model="queryParam.applicationBy" @change="change">
                <a-radio value="user">{{language['user']}}</a-radio>
                <a-radio value="role">{{language['role']}}</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>


          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>



    <!-- table区域-begin -->
      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
        :scroll="{x:1300}">

        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
        <!-- <a @click="handleEdit(record)" >区域设置</a>-->
            <a href="javascript:;" @click="handleAreaSettings(record.username,record.id)">区域设置</a>
        </span>


      </a-table>
    </div>
    <!-- table区域-end -->

    <user-modal ref="modalForm" @ok="modalFormOk"></user-modal>

    <password-modal ref="passwordmodal" @ok="passwordModalOk"></password-modal>

    <sys-user-area-modal ref="SysUserAreaModal"></sys-user-area-modal>

    <!-- 用户回收站 -->
    <user-recycle-bin-modal :visible.sync="recycleBinVisible" @ok="modalFormOk"/>
  </a-card>
</template>

<script>
  import UserModal from './modules/UserModal'
  import PasswordModal from './modules/PasswordModal'
  import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch, queryUserAreaTreeList,queryUserUserAreaList} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import SysUserAreaModal from "./modules/SysUserAreaModal";
  import JInput from '@/components/jeecg/JInput'
  import UserRecycleBinModal from './modules/UserRecycleBinModal'
  import JSuperQuery from '@/components/jeecg/JSuperQuery'
  import JThirdAppButton from '@/components/jeecgbiz/thirdApp/JThirdAppButton'


  export default {
    name: "UserList",
    mixins: [JeecgListMixin],
    components: {
      JThirdAppButton,
      SysUserAreaModal,
      UserModal,
      PasswordModal,
      JInput,
      UserRecycleBinModal,
      JSuperQuery
    },
    data() {
      return {
        description: '这是用户管理页面',
        queryParam: {applicationBy:'user'},
        recycleBinVisible: false,
        applicationOptions:[],
        selectedApplicationId:'',
        uploadSource:"platform",
        columns: [
                  {
                    title: '#',
                    dataIndex: '',
                    key:'rowIndex',
                    width:60,
                    align:"center",
                    customRender:function (t,r,index) {
                      return parseInt(index)+1;
                    }
                  },

          {
            title: '用户账号',
            align: "center",
            dataIndex: 'username',
            sorter: true
          },
          {
            title: '用户姓名',
            align: "center",
            dataIndex: 'realname',
          },
          {
            title: '头像',
            align: "center",
            dataIndex: 'avatar',
            scopedSlots: {customRender: "avatarslot"}
          },

          {
            title: '性别',
            align: "center",
            dataIndex: 'sex_dictText',
            sorter: true
          },
          {
            title: '用户类别',
            align: "center",
            dataIndex: 'userType_dictText',

          },
          {
            title: '工号',
            align: "center",
            dataIndex: 'workNo',

          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 170,
             fixed:"right"
          }

        ],
        superQueryFieldList: [
          { type: 'input', value: 'username', text: '用户账号', },
          { type: 'input', value: 'realname', text: '用户姓名', },
          { type: 'select', value: 'sex', dbType: 'int', text: '性别', dictCode: 'sex' },
        ],
        url: {
          syncUser: "/act/process/extActProcess/doSyncUser",
          list: "/sys/userArea/list",
          delete: "/sys/userArea/delete",
          deleteBatch: "/sys/userArea/deleteBatch",
          exportXlsUrl: "/sys/userArea/exportXls",
          importExcelUrl: "sys/userArea/importExcel",
        },
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    created() {
      //this.initApplicationList();
      // this.getThisapplication();
      this.application = this.$store.getters.application
      this.initDictConfig();

      if(this.$store.getters.application.applicationType === 'platform') {
        this.initApplicationList();
        this.loadData();
      }else{
        this.queryParam = {selectedApplicationId:this.application.id,applicationBy:'user'}
        console.log("------------------"+this.queryParam)
        this.loadData(1);
      }
    },
    methods: {

      searchReset() {
        if(this.$store.getters.application.applicationType === 'platform'){
          this.queryParam ={
            applicationBy:'user'
          }
        }else{
          this.queryParam = {selectedApplicationId:this.application.id,applicationBy:'user'}
        }
        this.loadData(1);
      },


      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar,this.uploadSource)
      },
      handleFrozen: function (id, status, username) {
        let that = this;
        //TODO 后台校验管理员角色
        if ('admin' == username) {
          that.$message.warning('管理员账号不允许此操作！');
          return;
        }
        frozenBatch({ids: id, status: status}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      handleChangePassword(username) {
        this.$refs.passwordmodal.show(username);
      },

      handleAreaSettings(username,id){
        let ids = "";
        queryUserUserAreaList({"userId":id}).then((res) => {
            if (res.success) {
              for (let i = 0; i < res.result.length; i++) {
                ids += res.result[i]["areaId"] + ",";
              }
              // this.$refs.sysUserAreaModal.agentSettings(username);
              this.$refs.SysUserAreaModal.loadTree("env_audit", ids, username,this.$store.getters.application.id)
              this.$refs.SysUserAreaModal.title = "编辑"
            }
          })
      },
      passwordModalOk() {
        //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
      },
      onSyncFinally({isToLocal}) {
        // 同步到本地时刷新下数据
        if (isToLocal) {
          this.loadData()
        }
      },
      initApplicationList(){
        let that = this;
        applicationList().then((res) => {
          if(res.success){
            that.applicationOptions = res.result;
            console.log('this.applicationOptions: ',this.applicationOptions)
          }
        })
      },
/*      bindApplication(record){
        this.$refs.UserApplicationModel.edit(record);
      },*/
    }

  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>